import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Play } from 'lucide-react';

interface StartNodeData {
  label?: string;
}

const StartNode: React.FC<NodeProps<StartNodeData>> = ({ data }) => {
  return (
    <div className="w-72 h-32 px-4 py-2 shadow-md rounded-md bg-white dark:bg-cap-dark border-2 border-green-500 relative flex flex-col items-center justify-center">
      <div className="flex items-center">
        <div className="rounded-full w-12 h-12 flex items-center justify-center bg-green-100 dark:bg-green-900/30">
          <Play className="w-6 h-6 text-green-600 dark:text-green-400" />
        </div>
        <div className="ml-2">
          <div className="text-lg font-bold text-gray-900 dark:text-warm-white">Start</div>
          <div className="text-gray-500 dark:text-gray-400">Workflow begins here</div>
        </div>
      </div>
      {/* Multiple handles for dynamic routing */}
      <Handle type="source" position={Position.Top} id="top" style={{ top: 0, left: '50%', transform: 'translate(-50%, -50%)' }} className="w-3 h-3 bg-green-500" />
      <Handle type="source" position={Position.Bottom} id="bottom" className="w-3 h-3 bg-green-500" />
      <Handle type="source" position={Position.Right} id="right" className="w-3 h-3 bg-green-500" />
      <Handle type="source" position={Position.Left} id="left" className="w-3 h-3 bg-green-500" />
    </div>
  );
};

export default StartNode; 